import { render, staticRenderFns } from "./DataDoctorInput.vue?vue&type=template&id=269a7d22&scoped=true"
import script from "./DataDoctorInput.vue?vue&type=script&lang=js"
export * from "./DataDoctorInput.vue?vue&type=script&lang=js"
import style0 from "./DataDoctorInput.vue?vue&type=style&index=0&id=269a7d22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "269a7d22",
  null
  
)

export default component.exports